import React, { useState } from "react";
import { Button, Col, Container, Nav, Row, Tab } from "react-bootstrap";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import TableLayout from "../../../components/TableLayout";
import dataHandler from "../../../hooks/dataHandler";
import { ACCOUNTING_LIST } from "../../../services/ApiCalls";
import CustomPagination from "../../../components/Common/CustomPagination";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { exportCsvHandler } from "../../../utilities/utilities";
import HotelAdminFilter from "../../../components/Common/HotelAdminFilter";
import { activeInactiveOptions, pendingOptions } from "../../../utilities/const";
import ButtonLoader from "../../../components/Common/ButtonLoader";
import AdminUserStat from "../../../components/Common/AdminUserStat";

const Accounting = () => {
  const [exportLoader, setExportLoader] = useState(false);
  const [exportpLoader, setExportpLoader] = useState(false);

  const { t } = useTranslation();
  const [dateRange, setDateRange] = useState({
    fromDate: "",
    toDate: "",
  });
  const {
    setBody,
    statusChangeHandler,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: ACCOUNTING_LIST,
    extraBody: {
      orderBy: "createdAt",
      sortOrder: -1
    }
  });

  const column = [
    {
      head: t("accounting.columns.serialNumber"),
      accessor: "#",
      component: (item, key) => {
        return <>{key < 9 ? `${key + 1}` : key + 1}</>;
      },
    },
    // {
    //   head: t("accounting.columns.transactionId"),
    //   accessor: "transactionId",
    //   component: (item) => (
    //     <>{item.transactionId ? item.transactionId : "--"}</>
    //   ),
    // },
    {
      head: t("accounting.columns.bookingId"),
      accessor: "bookingDetails",
      component: (item) => (
        <>{item.bookingDetails?.bookingId ? item.bookingDetails?.bookingId : "--"}</>
      ),
    },
    {
      head: t("accounting.columns.hotelName"),
      accessor: "hotelDetails",
      component: (item) => (
        <>{item.hotelDetails?.hotelName ? item.hotelDetails?.hotelName : "--"}</>
      ),
    },
    {
      head: t("accounting.columns.date"),
      accessor: "createdAt",
      component: (item) => <>{moment(item.createdAt).format("MM-DD-YYYY")}</>,
    },
    {
      head: t("accounting.columns.time"),
      accessor: "createdAt",
      component: (item) => <>{moment(item.createdAt).format("hh:mm A")}</>,
    },
    // {
    //   head: "Type",
    //   accessor: "type",
    // },
    {
      head: t("accounting.columns.totalamount", "Total Amount"),
      accessor: "amount",
      component: (item) => (
        <span className="text-nowrap">
          {item?.currencySymbol}
          {item?.amount}
        </span>
      ),
    },
    {
      head: t("accounting.columns.gatewayfee", "Gateway Fee"),
      accessor: "gateFee",
      component: (item) => (
        <span className="text-nowrap">
          {item?.currencySymbol}
          {item?.gateFee}
        </span>
      ),
    },
    {
      head: t("accounting.columns.vat", "VAT"),
      accessor: "vat",
      component: (item) => (
        <span className="text-nowrap">
          {item?.currencySymbol}
          {item?.vat}
        </span>
      ),
    },
    {
      head: t("accounting.columns.hotelEarning", "Hotel Earning"),
      accessor: "hotelPay",
      component: (item) => (
        <span className="text-nowrap">
          {item?.currencySymbol}
          {item?.hotelPay}
        </span>
      ),
    },
    {
      head: t("accounting.columns.commission", "Commision"),
      accessor: "platformCommission",
      component: (item) => (
        <span className="text-nowrap">
          {item?.currencySymbol}
          {item?.platformCommission}
        </span>
      ),
    },
    {
      head: t("accounting.columns.status"),
      accessor: "status",

    },
  ];
  const handleDateChange = (e) => {
    const { name, value } = e.target;

    const updatedRange = {
      ...dateRange,
      [name]: value,
    };

    setDateRange(updatedRange);

    // Update API body
    setBody((prev) => ({
      ...prev,
      page: 1, // reset pagination
      startDate: updatedRange.fromDate
        ? moment(updatedRange.fromDate).startOf("day").toISOString()
        : "",
      endDate: updatedRange.toDate
        ? moment(updatedRange.toDate).endOf("day").toISOString()
        : "",
    }));
  };

  return (
    <>
      <ConfirmationPop
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel({ show: false, dumpId: "" })}
        confirmHandler={() => setDeleteModel({ show: false, dumpId: "" })}
      />
      <AdminUserStat platform={data?.report} type={"transactions"} currency={data?.resdata[0]?.currencySymbol} />
      <section className="accounting py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12 ">
              <div className="d-flex  justify-content-between">
                <h4 className="mb-0 py-2 fw-bold text-dark text-capitalize">
                  {t("accounting.title")}
                </h4>
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <Tab.Container id="left-tabs-example" defaultActiveKey="Admin">
                <div className="d-flex align-items-center justify-content-between gap-10 flex-wrap">
                  {/* <Nav
                    variant="pills"
                    className="inline-flex rounded-pill pillsTab"
                    style={{ background: "#033E8A", maxWidth: "max-content" }}
                  >
                    <Nav.Item>
                      <Nav.Link
                        className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                        eventKey="Admin"
                      >
                        Admin Transactions
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className="rounded-pill d-flex align-items-center  justify-content-center position-relative"
                        eventKey="Withdrawal"
                      >
                        Withdrawal transaction
                      </Nav.Link>
                    </Nav.Item>
                  </Nav> */}
                  <div className="right">
                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-end gap-10 flex-wrap">
                      <li className="d-flex align-items-end gap-10 flex-wrap">
                        <label
                          style={{ whiteSpace: "nowrap" }}
                          htmlFor=""
                          className="form-label m-0 fw-sbold text-muted pb-2"
                        >
                          {t("accounting.labels.selectDateRange")}
                        </label>
                        <div className="d-flex align-items-center gap-10">
                          <div className="">
                            <p className="m-0 fw-sbold themeBlue">{t("accounting.labels.from")}</p>
                            <input
                              type="date"
                              name="fromDate"
                              value={dateRange.fromDate}
                              onChange={handleDateChange}
                              className="form-control"
                              style={{
                                height: 40,
                                fontSize: 12,
                                background: "#F9F9F9",
                              }}
                            />
                          </div>
                          <div className="">
                            <p className="m-0 fw-sbold themeBlue">{t("accounting.labels.to")}</p>
                            <input
                              type="date"
                              name="toDate"
                              value={dateRange.toDate}
                              onChange={handleDateChange}
                              style={{
                                height: 40,
                                fontSize: 12,
                                background: "#F9F9F9",
                              }}
                              className="form-control"
                            />
                          </div>
                        </div>
                      </li>

                      <li className="d-flex">
                        <Button
                          className="d-flex mx-2 align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                          style={{ height: 40, minWidth: 100, fontSize: 12 }}
                          type="button"
                          onClick={() =>
                            exportCsvHandler("accounting", setExportLoader)
                          }
                        >

                          {exportLoader ? (
                            <ButtonLoader />
                          ) : (
                            t("manageUser.exportCsv")
                          )}
                        </Button>

                        <Button
                          className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                          style={{ height: 40, minWidth: 100, fontSize: 12 }}
                          type="button"
                          onClick={() =>
                                  {const sd = dateRange.fromDate
                            ? moment(dateRange.fromDate).startOf("day").toISOString()
                            : ""
                            const ed = dateRange.toDate
                              ? moment(dateRange.toDate).endOf("day").toISOString()
                              : ""
                              exportCsvHandler("accounting", setExportpLoader, "pdf",sd,ed)}
                          }
                        >

                          {exportpLoader ? (
                            <ButtonLoader />
                          ) : (
                            t("manageUser.exportPdf", "Export PDF")
                          )}
                        </Button>

                      </li>
                    </ul>
                  </div>
                </div>
                <Col lg="12" className="my-2">
                  <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                    <div className="left">
                      <HotelAdminFilter
                        body={body}
                        searchHandler={searchHandler}
                        setBody={setBody}
                        type="transaction"
                        statusFilterOptionArr={pendingOptions}
                      />
                    </div>
                  </div>
                </Col>
                <div className="my-2 pt-3">
                  <TableLayout column={column} data={data?.resdata} loader={loader} />
                  <CustomPagination
                    body={body}
                    setBody={setBody}
                    pageChangeHandler={paginationHandler}
                    total={total}
                  />
                </div>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Accounting;
